<template>
  <div>
    <div class="section section-signup page-header" :style="signupImage">
      <div class="container">
        <div class="md-layout">
          <div
              class="md-layout-item md-size-40 md-medium-size-60 md-small-size-100 md-xsmall-size-100 mx-auto text-center"
          >
            <reset-password v-if="$route.params.token" :token=$route.params.token></reset-password>
            <div v-else>
              <login v-if="nameForm === 'login'" @changeForm="nameForm = 'register'" @resetPassword="nameForm = 'reset'"/>
              <register v-if="nameForm === 'register'" @changeForm="nameForm = 'login'"/>
              <restore-password v-if="nameForm === 'reset'"/>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>

</template>
<script>

import Login from "./components/account/Login";
import Register from "./components/account/Register";
import ResetPassword from "./components/account/ResetPassword";
import RestorePassword from "./components/account/RestorePassword";

export default {
  name: 'Account',
  components: {RestorePassword, ResetPassword, Login, Register},
  data() {
    return {
      user: null,
      nameForm: 'login'
    }
  },
  props: {
    header: {
      type: String,
      default: require("@/assets/img/bg11.jpg")
    }
  },
  computed: {
    signupImage() {
      return {
        backgroundImage: `url(${this.header})`
      };
    }
  },
  methods: {

  }
}
</script>